import React, { useMemo } from 'react';
import { Chip } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

interface QuadrimestreCountdownProps {
  quadrimestre: string; // 'Q1', 'Q2', 'Q3'
  ano: number;
}

const QuadrimestreCountdown: React.FC<QuadrimestreCountdownProps> = ({ quadrimestre, ano }) => {
  const { diasRestantes, label, chipColor } = useMemo(() => {
    const endDates: Record<string, string> = {
      Q1: `${ano}-04-30`,
      Q2: `${ano}-08-31`,
      Q3: `${ano}-12-31`,
    };
    const endStr = endDates[quadrimestre];
    if (!endStr) return { diasRestantes: -1, label: '', chipColor: 'default' as const };

    const end = new Date(endStr + 'T23:59:59');
    const now = new Date();
    const diffMs = end.getTime() - now.getTime();
    const dias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    if (dias < 0) return { diasRestantes: dias, label: 'Encerrado', chipColor: 'default' as const };
    if (dias <= 15) return { diasRestantes: dias, label: `${dias}d restantes`, chipColor: 'error' as const };
    if (dias <= 30) return { diasRestantes: dias, label: `${dias}d restantes`, chipColor: 'warning' as const };
    if (dias <= 60) return { diasRestantes: dias, label: `${dias}d restantes`, chipColor: 'info' as const };
    return { diasRestantes: dias, label: `${dias}d restantes`, chipColor: 'success' as const };
  }, [quadrimestre, ano]);

  if (!label) return null;

  return (
    <Chip
      icon={<AccessTimeIcon sx={{ fontSize: 14 }} />}
      label={label}
      size="small"
      color={chipColor}
      variant={diasRestantes < 0 ? 'outlined' : 'filled'}
      sx={{ height: 24, fontSize: '0.75rem', '& .MuiChip-icon': { ml: 0.5 } }}
    />
  );
};

export default QuadrimestreCountdown;
